import {SalesDashboardRepository} from '../repository/SalesDashboardRepository';
import type {BaseResponse} from '../../../Data/types/BaseResponse';
import type {AgingBucketDTO} from '../api/SalesDashboardAPIDataSource';

export class GetAgingReportUseCase {
  constructor (private readonly repo: SalesDashboardRepository) {}

  async execute (params: {storeId?: number; dateFrom?: string; dateTo?: string}): Promise<BaseResponse<AgingBucketDTO>> {
    return this.repo.getAgingReport(params);
  }
}


